import styles from "./Spinner.module.scss";

export interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

/** A reduced-motion-safe spinner. Used inside the width-stable loading Button.*/
export function Spinner({ size = 16, className, label = "Loading" }: SpinnerProps) {
  return (
    <span
      className={`${styles.spinner} ${className ?? ""}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label={label}
    />
  );
}
